import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../../context/AuthContext";

const LINKS = [
  { to: "/products", label: "Digital Products" },
  { to: "/about", label: "About" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 ${isActive ? "text-white" : "text-slate-400 hover:text-white"}`;

export const Navbar = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const home = user?.role === "admin" ? "/admin" : "/dashboard";

  return (
    <header className="sticky top-0 z-40 border-b border-white/[0.06] bg-[#0b0f17]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkCls} data-testid={`nav-${l.to.slice(1)}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          {user ? (
            <Link to={home} className="btn-primary py-2.5" data-testid="nav-dashboard-btn">Go to dashboard</Link>
          ) : (
            <>
              <Link to="/login" className="text-sm font-semibold text-slate-200 hover:text-white" data-testid="nav-login-btn">Log in</Link>
              <Link to="/register" className="btn-primary py-2.5" data-testid="nav-register-btn">Create account</Link>
            </>
          )}
        </div>
        <button className="rounded-lg p-2 text-slate-200 lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/[0.06] bg-[#0b0f17] px-5 pb-6 pt-3 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-slate-200 hover:bg-white/5">
                {l.label}
              </NavLink>
            ))}
          </div>
          <div className="mt-4 grid grid-cols-2 gap-3">
            {user ? (
              <Link to={home} onClick={() => setOpen(false)} className="btn-primary col-span-2">Go to dashboard</Link>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="btn-ghost">Log in</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="btn-primary">Create account</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
